import { render } from "./CustomHeader-editor.vue?vue&type=template&id=139a005f&scoped=true"
import script from "./CustomHeader-editor.vue?vue&type=script&lang=js"
export * from "./CustomHeader-editor.vue?vue&type=script&lang=js"

import "./CustomHeader-editor.vue?vue&type=style&index=0&id=139a005f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139a005f"]])

export default __exports__